import { render, staticRenderFns } from "./CiGenericNavigation.vue?vue&type=template&id=64edb83e&scoped=true&"
import script from "./CiGenericNavigation.vue?vue&type=script&lang=js&"
export * from "./CiGenericNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CiGenericNavigation.vue?vue&type=style&index=0&id=64edb83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64edb83e",
  null
  
)

component.options.__file = "CiGenericNavigation.vue"
export default component.exports